import AvailabilityReducer from './availability_reducer';

export default AvailabilityReducer;
